module.exports = __webpack_public_path__ + "img/menu-bg5.ce606010.png";